<script>
import _ from "lodash";
const TheMeetingVoteCommentAchTypeCard = () => import('./TheMeetingVoteCommentAchTypeCard.vue')

export default {
  name: "TheMeetingStatementAchievementTypeCard",

  components: {
    TheMeetingVoteCommentAchTypeCard
  },

  props: {
    statement: Object,
  },

  data() {
    return {
      menu: false,
    };
  },

  computed: {
    isCommentAchievementTypePresent() {
      return !_.isNil(this.statement.comment_achievement_type)
    },

    achievementType() {
      if (_.isEmpty(this.statement)) return ""
      return this.statement.prtf_achievement_type_name;
    },
  },
}
</script>

<template>
  <v-card
    flat
    outlined
    rounded="xl"
    class="d-flex flex-row align-center"
  >
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          {{achievementType}}
        </v-list-item-title>
        <v-list-item-subtitle>
          Выбранный тип деятельности
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-spacer/>

    <v-menu
      top
      content-class="rounded-xl"
      max-width="345px"
      offset-y
      left
      :close-delay="2000"
      open-on-click
      v-model="menu"
    >
      <template #activator="{ on, attrs }">
        <v-btn
          color="error"
          small
          outlined
          class="rounded-xl"
          v-bind="attrs"
          v-on="on"
          v-show="isCommentAchievementTypePresent"
        >
          Ком-ий
          <v-icon small right>
            fa-comment
          </v-icon>
        </v-btn>
      </template>

      <the-meeting-vote-comment-ach-type-card
        v-if="isCommentAchievementTypePresent"
        :statement="statement"
        :comment="statement.comment_achievement_type"
      />

    </v-menu>

    <div class="mx-1"></div>

    <v-btn
      class="rounded-xl white--text mr-2"
      small
      elevation="0"
      color="teal darken-3"
      :disabled="isCommentAchievementTypePresent"
      @click="$emit('showAchievementTypeDialog')"
    >
      Ред-ть
      <v-icon right small>
        fa-edit
      </v-icon>
    </v-btn>
  </v-card>
</template>

<style scoped>

</style>